import React from 'react';
import { useRecoilValue } from 'recoil';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { useTranslation } from 'react-i18next';
import { Container, Tab, Tabs } from '@mui/material';
import { a11yProps, TabPanels } from 'components/mui/Tabs';
import useSwiperTabs from 'hooks/useSwiperTabs';
import useDidUpdateEffect from 'hooks/useDidUpdateEffect';
import { CompanyType } from 'models/CompanyModel';
import NonAssigned from 'modules/transportation/views/NonAssigned';
import Pending from 'modules/transportation/views/Pending';
import InTransit from 'modules/transportation/views/InTransit';
import Delivered from 'modules/transportation/views/Delivered';
import Canceled from 'modules/transportation/views/Canceled';
import auth from 'recoil/atoms/auth';


const tabsMaster = [
    'non_assigned',
    'pending',
    'in_transit',
    'delivered',
    'canceled',
];

const tabsAgent = [
    'pending',
    'in_transit',
    'delivered',
];

const Transportation = () => {
    const my = useRecoilValue(auth);
    const tabs = my.type === CompanyType.Master ? tabsMaster : tabsAgent;
    const {t} = useTranslation();
    const [status, setStatus] = useQueryParam('status', withDefault(StringParam, 'pending'));
    const {index, setIndex, setSwiper} = useSwiperTabs(tabs.indexOf(status));

    const change = (idx: number, fromSwiper?: boolean) => {
        setIndex(idx, fromSwiper);
        setStatus(tabs[idx]);
    };

    useDidUpdateEffect(() => setIndex(tabs.indexOf(status)), [status]);

    const id = 'transportations';

    const tabButtons = (
        <Tabs
            variant="scrollable"
            value={index}
            onChange={(_, v) => change(v)}
            aria-label="Tranportation tabs"
        >
            {tabs.map((tab, i) => {

                return <Tab key={tab} label={t(`status_${tab}`)} {...a11yProps(id, i)} />
            })}
        </Tabs>
    );

    return (
        <Container maxWidth="md" sx={{mt: 2}}>
            {tabButtons}

            <TabPanels
                active={index}
                id={id}
                setIndex={change}
                setSwiper={setSwiper}
                narrow
                tabs={my.type === CompanyType.Master ? [
                    <NonAssigned/>,
                    <Pending/>,
                    <InTransit/>,
                    <Delivered/>,
                    <Canceled/>,
                ]: [
                    <Pending/>,
                    <InTransit/>,
                    <Delivered/>,
                ]}
            />
        </Container>
    );
};

export default Transportation;
